import {
  END_HPA,
  HIDE_HPA_BEGIN_MODAL,
  HIDE_HPA_CHANGE_MODAL,
  HIDE_HPA_NOT_ALLOWED_MODAL,
  SHOW_HPA_BEGIN_MODAL,
  SHOW_HPA_CHANGE_MODAL,
  SHOW_HPA_NOT_ALLOWED_MODAL,
  START_HPA,
} from './actions';

const initialState = {
  hpaBeginModalIsVisible: false,
  hpaChangeModalIsVisible: false,
  hpaNotAllowedModalIsVisible: false,
  isHpa: false,
  hpaSessionId: null,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_HPA_NOT_ALLOWED_MODAL:
      return {
        ...state,
        hpaNotAllowedModalIsVisible: true,
      };
    case HIDE_HPA_NOT_ALLOWED_MODAL:
      return {
        ...state,
        hpaNotAllowedModalIsVisible: false,
      };
    case SHOW_HPA_BEGIN_MODAL:
      return {
        ...state,
        hpaBeginModalIsVisible: true,
      };
    case HIDE_HPA_BEGIN_MODAL:
      return {
        ...state,
        hpaBeginModalIsVisible: false,
      };
    case SHOW_HPA_CHANGE_MODAL:
      return {
        ...state,
        hpaChangeModalIsVisible: true,
      };
    case HIDE_HPA_CHANGE_MODAL:
      return {
        ...state,
        hpaChangeModalIsVisible: false,
      };
    case START_HPA:
      return {
        ...state,
        isHpa: true,
        hpaSessionId: action.payload,
      };
    case END_HPA:
      return {
        ...state,
        isHpa: false,
        hpaChangeModalIsVisible: false,
        hpaSessionId: null,
      };
    default:
      return state;
  }
};
